<template>
	<section class="active-call" :class="activeCallClass">
		<loader v-if="!activeCall" class="loader--white loader--compact"/>
		<template v-else>
			<div v-if="!closingCall" class="active-call__timer">
				<header class="flex gap=2 content-between items-center">
					<p class="alpha" v-html="callDuration"/>
					<ul class="active-call__actions">
						<li>
							<button
								class="button button--white--small" @click.prevent="closingCall = true">End Call
							</button>
						</li>
					</ul>
				</header>
			</div>
			<div v-if="closingCall" class="active-call__outcome" :class="outcomeClass">
				<header class="flex gap=2 content-between items-center">
					<h2 class="alpha">Call Outcome</h2>
					<ul class="active-call__actions">
						<li>
							<button
								class="button button--white--small" @click.prevent="reset()">Continue Call
							</button>
						</li>
					</ul>
				</header>
				<form class="active-call__form mt-2" @submit.prevent>
					<label
						v-for="(outcome, outcomeIndex) in activeCall.possibleOutcomes"
						:class="labelClass(outcome)"><span
						class="beta"
						v-html="$present('ucWords', outcomeIndex)"/>
						<input v-model="form.data.outcome" class="sr-only" type="radio" name="outcome" :value="outcome">
						<button
							v-if="form.data.outcome === outcome" class="button button--white--small"
							@click.prevent="endCall()">Confirm
						</button>
					</label>
				</form>
			</div>
		</template>
	</section>
</template>
<script>
import {mapActions, mapState} from "vuex";
import AccordionGroup from "../common/components/v-accordion/AccordionGroup.vue";
import Accordion from "../common/components/v-accordion/Accordion.vue";
import Address from "./Address.vue";

export default {
	components: {Address, Accordion, AccordionGroup},
	data() {
		return {
			closingCall: false,
			form: this.newForm({
				outcome: "",
			}),
		};
	},
	computed: {
		...mapState("activeCall", [
			"client",
			"startingCall",
			"activeCall",
			"callDuration",
		]),
		activeCallClass() {
			return {
				"active-call--active": this.startingCall || this.activeCall,
			};
		},
		outcomeClass() {
			return {
				"active-call__outcome--open": this.closingCall,
			};
		},
	},

	methods: {
		...mapActions("activeCall", [
			"setActiveCall",
		]),
		closeCall() {
			this.closingCall = true;
		},
		endCall() {
			this.form.patch(this.route("call/:call/end", [this.activeCall])).then(response => {
				this.eventBus.$emit("activeCallEnded", response.data);
				this.eventBus.$handle("activeCallEnded", response.data);
				this.setActiveCall();
				this.reset();
			});
		},
		reset() {
			this.closingCall = false;
			this.form.reset();
		},
		labelClass(outcome) {
			return {
				"unselected": this.form.data.outcome !== "" && this.form.data.outcome !== outcome,
				"flex content-center items-center": this.form.data.outcome !== outcome,
				"flex gap-2 content-between items-center selected": this.form.data.outcome === outcome,
			};
		},
	},
};
</script>
